export const Brands = [
    {
        title: "Freeman Jones",
        contactUsLink: 'https://www.financialwellnessgroup.co.uk/contact-us/'
    }
];

export interface AccountNumberReq {
    accountNumber: string;
    uuid: string;
    token: string;
    lastName: string;
    dateOfBirth: string;
    postcode: string;
    fileTye: string;
    creditorDocType: string;
    incomeDocType: string;
}

export type AppContextType = {
    accountNumberReq: AccountNumberReq;
    setAccountNumberReq: (accountNumberReq: AccountNumberReq) => void;
}

export const UPLOAD_DOC_TYPES = [
    { type: "INCOME", heading: "Proof of Income", description: "Wage slips, P60. P45, tax returns, Benefits, Redundancy, Bank Statements", css: 'form__radio' },
    { type: "INCOME_EXPENDITURE", heading: "Income and Expenditure", description: "Your latest Income and Expenditure document & supporting evidence (bills etc)", css: 'form__radio' },
    { type: "CREDITOR", heading: "Creditor Post", description: "Letters you have received from your creditors", css: 'form__radio__2' },
    { type: "CAR_HP_DOCUMENTS", heading: "Car HP Documents", description: "Documents we have requested relating to a Car HP approval", css: 'form__radio__2r5' },
    { type: "PROPERTY_DOCUMENTS", heading: "Property Document", description: "Documents relating to your Mortgaged property (if you have one)", css: 'form__radio__2r5' },
    { type: "OTHERS", heading: "Other/General", description: "Anything else that doesn't meet the above", css: 'form__radio__2' }
];

export const CREDITOR_FILE_TYPES = [
    { type: "DEBIT", heading: "Additional Debt", description: "Proof of a debt that you don't believe is included already within your arrangement", css: 'form__radio' },
    { type: "LETTER", heading: "General Letter / Default Letter", description: "A general letter from a creditor you have received (that we already know about)", css: 'form__radio' },
    { type: "PPI", heading: "PPI Document", description: "Letters relating to PPI - includes any Claim Management documents you have received", css: 'form__radio' }
];

export const INCOME_FILE_TYPES = [
    { type: "WAGE", heading: "Wage slips", description: "Wage slips you have received from your employer", css: 'form__radio__2' },
    { type: "P60_HMRC", heading: "P60 / HMRC", description: "The end of year document summarising your earnings for the financial year", css: 'form__radio__3' },
    { type: "P45", heading: "P45", description: "Proof that your job has come to an end", css: 'form__radio__2' },
    { type: "SELF_ASSESSMENT", heading: "Self Assessment/Tax Return", description: "Your Tax Return or self Assessment received from HMRC or accountant", css: 'form__radio__3' },
    { type: "BENEFITS", heading: "Benefits", description: "Proof of your benefit income, including Universal Credit etc.", css: 'form__radio__2r5' },
    { type: "INCOME_PROOF", heading: "Redundancy", description: "Evidence of your Redundancy Payslip or Letter", css: 'form__radio__2' },
    { type: "BANK_STATEMENTS", heading: "Bank Statements/Other", description: "Any other income you may receive that you wish to display to us", css: 'form__radio__2r5' }
];